// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import cx from 'classnames';
import PropTypes from 'prop-types';
import Spinner from 'shared/components/Spinner';
import styles from './ToggleSwitch.module.scss';

/** @typedef {{
  id: string,
  checked: boolean,
  loading?: boolean,
  onChange: () => any,
  showStateLabel?: boolean,
  onStateLabel?: string,
  offStateLabel?: string
} & React.InputHTMLAttributes<HTMLInputElement>} ToggleSwitchPropsType */

/** @type { React.ValidationMap<ToggleSwitchPropsType> } */
const propTypes = {
  id: PropTypes.string.isRequired, // NB: This is required so that the control is clickable (it depends on `htmlFor`)
  loading: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  showStateLabel: PropTypes.bool.isRequired,
  onStateLabel: PropTypes.string.isRequired,
  offStateLabel: PropTypes.string.isRequired,
};

/** @type { StatelessComponent<ToggleSwitchPropsType> } */
const ToggleSwitch = ({
  id,
  checked,
  loading,
  onChange,
  showStateLabel,
  onStateLabel,
  offStateLabel,
  ...props
}) => (
  <div className={styles.container}>
    <input
      type="checkbox"
      id={id}
      onChange={onChange}
      className={styles.toggle_switch}
      checked={checked}
      {...props}
    />
    <label id={`label-${id}`} htmlFor={id} style={{ margin: 0 }}>
      <div
        className={cx(
          styles.loading_indicator_container,
          loading
            ? styles.loading_indicator_container__active
            : styles.loading_indicator_container__inactive
        )}
      >
        <Spinner />
      </div>
    </label>
    {showStateLabel && (
      <span className={cx(styles.state_label, checked ? styles.on : styles.off)}>
        {checked ? onStateLabel : offStateLabel}
      </span>
    )}
  </div>
);

ToggleSwitch.displayName = 'ToggleSwitch';
ToggleSwitch.propTypes = propTypes;

ToggleSwitch.defaultProps = {
  loading: false,
  showStateLabel: false,
  onStateLabel: 'On',
  offStateLabel: 'Off',
};

export default ToggleSwitch;
